const Footer = () => {
  return (
    <section className='footer' id='bottom'>
      <h1>Adib Zaini</h1>
    </section>
  );
};

export default Footer;
